export default __webpack_public_path__ + "static/media/elrond.14bd7984.svg";